<template>
  <validation-provider
    :vid="vid"
    :rules="validation"
    :name="errorName || label"
    v-slot="{ errors }"
  >
    <brb-uploader
      v-model="model"
      v-bind="$attrs"
      v-on="$listeners"
      :label="label"
      :required="required"
      :error="errors && errors.length ? errors[0] : undefined"
    />
  </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import BrbUploader from './BrbUploader.vue'

export default {
  name: 'BrbUploaderWrapper',
  components: {
    ValidationProvider,
    BrbUploader
  },
  props: {
    value: {
      type: [String, null],
      default: null
    },
    validation: {
      type: [String, Object],
      default: null
    },
    label: String,
    errorName: String,
    vid: String
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    required() {
      if (this.validation) {
        if (typeof this.validation === 'string')
          return this.validation.includes('required')

        if (
          typeof this.validation === 'object' &&
          Object.keys(this.validation).includes('required')
        )
          return this.validation.required
      }

      return false
    }
  }
}
</script>
